import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";
import {CustomerGroup} from "@/models";

export class CustomerGroupService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    GetAllCustomerGroups(query = '', cancelToken?: AbortSignal) {
        return this.baseApiFactory.getData<CustomerGroup[]>('/api/CustomerGroup?' + query, null, cancelToken);
    }

    GetCustomerGroupsByCountry(id: number, cancelToken?: AbortSignal) {
        return this.baseApiFactory.getData<CustomerGroup[]>(`/api/CustomerGroup/country/${id}`, null, cancelToken);
    }

    GetCustomerGroupsByDistributor(id: number, cancelToken?: AbortSignal) {
        return this.baseApiFactory.getData<CustomerGroup[]>(`/api/CustomerGroup/distributor/${id}`, null, cancelToken);
    }

    listCustomerGroupsManagement(filter: {
        distributors?: string,
        name?,
        shipTo?,
        infotext?,
        storeViewId?,
        distributorNumber?,
        isActiveGuid?,
        showInfoText?,
        showGroupPrice?,
        allowInvoice?,
        registerEmailOption?,
        isActive?,
        page?,
        size?
    }, cancelToken?: AbortSignal) {
        return this.baseApiFactory.getData<CustomerGroup[]>('/api/CustomerGroup', filter, cancelToken);
    }

    InsertCustomerGroup(value) {
        return this.baseApiFactory.post<boolean>('/api/CustomerGroup', value);
    }

    UpdateCustomerGroup(value) {
        return this.baseApiFactory.put<boolean>('/api/CustomerGroup', value);
    }

    DeleteCustomerGroup(id) {
        return this.baseApiFactory.delete<boolean>('/api/CustomerGroup/' + id);
    }
}

lazyRegister.service('CustomerGroupService', CustomerGroupService);